export default __webpack_public_path__ + "static/044-bbd2001846f64fd3048871d11b808802.jpg";